import axios from '@/axiosInstance.ts'

export interface HttpChangePhotographerStatusOptions {
    payload:
        | {
              status: 'deactivated'
              deactivation_reason: string
              suspension_reason?: never
          }
        | {
              status: 'suspended'
              suspension_reason: string
              deactivation_reason?: never
          }
        | {
              status: 'active_available' | 'active_unavailable'
              deactivation_reason?: never
              suspension_reason?: never
          }
    urlParams: {photographerId: number; adminAccessToken: string}
}
export const httpChangePhotographerStatus = ({payload, urlParams}: HttpChangePhotographerStatusOptions) => {
    return axios.post(`/admin/photographers/${urlParams.photographerId}/status`, payload, {
        headers: {Authorization: `Bearer ${urlParams.adminAccessToken}`},
        skipAuthHeader: true
    })
}

type HttpGetCancelReasonsOptions = {
    urlParams: {adminAccessToken: string}
}
export const httpGetCancelReasons = ({urlParams}: HttpGetCancelReasonsOptions) =>
    axios.get(`reasons/cancel`, {
        headers: {Authorization: `Bearer ${urlParams.adminAccessToken}`},
        skipAuthHeader: true
    })

type HttpDeleteAssignmentOptions = {
    urlParams: {assignmentId: number; adminAccessToken: string}
    params: {
        cancellation_type: 'soft_cancellation' | 'hard_cancellation'
        reason_id: number
        notes?: string
    }
}
export const httpDeleteAssignment = ({urlParams, params}: HttpDeleteAssignmentOptions) => {
    return axios.delete(`/admin/assignments/${urlParams.assignmentId}`, {
        headers: {Authorization: `Bearer ${urlParams.adminAccessToken}`},
        params,
        skipAuthHeader: true
    })
}

export interface HttpImpersonateExchangeOptions {
    payload: {token: string}
}
/**
 * Exchanges the one-time verification token coming from the admin app for the real tokens.
 * Public endpoint: no session exists yet, so no Authorization header must be sent.
 * The explicit `Authorization: undefined` also drops the instance default header, which is
 * built once at module load and would otherwise survive clearing the stored tokens.
 */
export const httpImpersonateExchange = ({payload}: HttpImpersonateExchangeOptions) => {
    return axios.post(`/navigate/impersonate/exchange`, payload, {
        headers: {Authorization: undefined},
        skipAuthHeader: true
    })
}

type HttpUserAdminMeOptions = {
    urlParams: {adminAccessToken: string}
}
export const httpUserAdminMe = ({urlParams}: HttpUserAdminMeOptions) => {
    return axios.get(`/admin/me`, {
        headers: {Authorization: `Bearer ${urlParams.adminAccessToken}`},
        skipAuthHeader: true
    })
}
